import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useDispatch, useSelector } from "react-redux";

import { useSnackbar } from "notistack";
import Spinner from "../../components/Spinner";
import { fetchApiKey } from "../../services/common/workspace/slice";
import { Stack, Typography } from "@mui/material";
import CardContainer from "../../components/CardContainer";
import { StyledButton } from "../../components/StyledButton";

import { makeStyles } from "@material-ui/core/styles";
import { openPage } from "../../util/helpers";

const useStyles = makeStyles({
    cover_image_link: {
        textDecoration: "underline",
        color: "#FF601D",
        marginTop: "20px",
        cursor: "pointer !important",
    },
});

const ApiKeyPage = () => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();

    const workspaceStates = useSelector((state) => state.workspaces);

    const { active_workspace } = workspaceStates?.logintoWorkspaceState;
    const { isloading, errors, api_key } = workspaceStates?.fetchApiKeyState;

    useEffect(() => {
        dispatch(fetchApiKey({ id: active_workspace?.slug }));
    }, [active_workspace]);

    useEffect(() => {
        if (isloading === "failed" && errors != null) {
            enqueueSnackbar(errors, {
                variant: "error",
            });
        }
    }, [isloading, errors]);

    const copyTextToClipboard = (text) => {
        if (!navigator.clipboard) {
            console.log("Navigator.clipboard is not supported");
            return;
        }
        navigator.clipboard.writeText(text).then(
            function () {
                console.log("Copying to clipboard was successful!");
            },
            function (err) {
                console.error("Could not copy text: ", err);
            },
        );
    };

    return (
        <Grid container spacing={2}>
            <Grid container item md={5}>
                <Grid item md={12}>
                    <Typography variant="h5">API Key</Typography>
                    <Typography
                        sx={{ marginTop: "10px", marginBottom: "10px" }}
                    >
                        This API key can be used for authentication to the EDIA
                        API every time an API request is made. Like passwords,
                        API keys should remain a secret.
                    </Typography>
                </Grid>
                <Grid item md={12}>
                    {isloading === "processing" ? (
                        <Spinner size={25} />
                    ) : (
                        <Stack direction="column" spacing={2}>
                            <CardContainer>
                                <Typography> {api_key?.api_key}</Typography>
                            </CardContainer>
                            <Stack direction="row">
                                <Typography>Status:</Typography>
                                <Typography sx={{ marginLeft: "3px" }}>
                                    {api_key?.enabled ? (
                                        <span style={{ color: "green" }}>
                                            enabled
                                        </span>
                                    ) : (
                                        <span style={{ color: "red" }}>
                                            disabled
                                        </span>
                                    )}
                                </Typography>
                            </Stack>
                            <StyledButton
                                variant="contained"
                                sx={{ width: "230px" }}
                                onClick={() => {
                                    copyTextToClipboard(api_key?.api_key);
                                }}
                            >
                                Copy to clipboard
                            </StyledButton>
                            <p>
                                <span>
                                    For more information about the EDIA
                                    API, check out our{" "}
                                </span>
                                <span
                                    className={classes?.cover_image_link}
                                    onClick={() => {
                                        openPage(
                                            window?.account?.DOCUMENTATION_URL,
                                        );
                                    }}
                                >
                                    documentation{" "}
                                </span>
                            </p>
                        </Stack>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ApiKeyPage;
